// extracted by mini-css-extract-plugin
export default {"screen":"style_screen__a9grb"};